import type {Login} from '../../types'

const initialState: Login = {
  isAuthenticated: false,
  isLoading: false,
  authError: '',
  isTokenExpired: false,
}

export default (state: Login = initialState, action): Login => {
  const {type, payload} = action

  switch (type) {
    case 'FETCH_TOKEN':
      return {
        ...state,
        isAuthenticated: false,
        isLoading: true,
        isTokenExpired: false,
      }
    case 'FETCH_TOKEN_SUCCESS':
      if (payload && payload.token) {
        return {
          ...state,
          isAuthenticated: true,
          isLoading: false,
          authError: '',
          isTokenExpired: false,
        }
      }
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        authError: 'Please enter correct credentials.',
        isTokenExpired: false,
      }
    case 'FETCH_TOKEN_FAILURE':
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        authError: 'Error in authenticating the user, please try again later.',
        isTokenExpired: false,
      }
    case 'LOG_OUT':
      return {
        ...initialState,
        isTokenExpired: (payload && payload.isTokenExpired) ? payload.isTokenExpired : false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/login/reducer.js